import React, {Fragment} from 'react';
import Box from '../layout/Box';
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import {
    BarcodeFormatter,
    CurrencyFormatter, ProductColumn,
    ProductSelect,
    productTooltip,
    UnitFormatter
} from "../../utils/formatters";
import BoxEditor from "./BoxEditor";
import Select from "../form/Select";
import {loadComponent} from "../../utils/components";
import ComponentConfig from "../form/ComponentConfig";
import connect from "react-redux/es/connect/connect";
import ComponentLoader from "../form/ComponentLoader";

class ShopItemStockEditor extends React.Component {

    state = {
        filter: ["store"],
        locations: []
    };

    componentDidMount() {
        this.reloadLocations();
    }

    reloadLocations = () => {
        if (!this.state.locations.length) {
            this.setState({}, async () => {
                const allLocation = await loadComponent("componentlist", {
                    component: "location",
                    itemsperpage: 0,
                    view: [this.props.locationConfig.idfield],
                    filter: [
                        {
                            field: "roles.optionid",
                            value: "4" // ShopSupplyStore
                        },
                        {
                            field: "partner",
                            value: this.props.PointOfSale.partner.partner_id
                        }
                    ]
                });
                this.setState({locations: allLocation.items});
            });
        }
    }

    render() {
        const partner_id = this.props.PointOfSale.partner.partner_id;
        const product_id = this.state.product_id;
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const sortable = true;
        const filterable = true;
        const columns = {
            "displayname": {
                ...ProductColumn("id"),
                width: 3,
            },
            "category.name": {
                header: 'Árutípus',
                width: 1,
                sortable,
                filterable
            },
            "sku": {
                header: 'ISBN',
                width: 1,
                sortable,
                filterable
            },
            "listprice": {
                header: 'Listaár',
                width: 1,
                sortable,
                filterable,
                className: "currency",
                renderer: CurrencyFormatter
            },
            "qty": {
                header: 'Darabszám',
                width: 1,
                sortable,
                filterable,
                renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                className: "unit"
            },
            "shadowqty": {
                header: '- Hiány/ + Többlet',
                width: 1,
                sortable,
                filterable,
                renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                className: "unit"
            },
            "store.name": {
                header: 'Raktár',
                width: 2,
                sortable,
                filterable
            },
            "authors": {
                header: 'Szerzők',
                width: 2,
                renderer: (authors) => {
                    return authors.map((author) => author.name).reduce((prev, curr) => [prev, prev ? ', ' : '', curr], null)
                }
            }
        };
        const filter = [
            {
                field: "partner",
                value: partner_id
            },
            {
                field: "base_product_id",
                value: product_id
            },
            {
                field: "store",
                value: this.state.locations.map((location) => location[this.props.locationConfig.idfield]),
                operator: "in"
            }
        ];
        return (
            <Fragment>
                <List
                    theme="default"
                    header="Termék készlet"
                >
                    <Select
                        name="product"
                        objectValue={true}
                        component="product"
                        labelKey="displayname"
                        valueKey="base_product_id"
                        optionsTemplate={ProductSelect}
                        isClearable={true}
                        autoSelect={true}
                        saveChanges={(field, value) => {
                            this.setState({product_id: (value || {}).base_product_id});
                        }}
                        storeType="remote"
                        label="Termék"
                        searchFormatter={BarcodeFormatter}
                        placeholder="Vonalkód vagy cím"
                        value={product_id}
                    />
                    {product_id && <SelectorGrid
                        gridid={this.props.gridid || "stockList"}
                        className={"p-small-table"}
                        loading={this.props.isLoading}
                        componentConfig={this.props.componentConfig}
                        view={[...Object.keys(columns), "id"]}
                        exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel", addFilters: true}]}
                        aggregations={{
                            fields: {
                                "qty": {
                                    field: "qty", type: "SUM"
                                }
                            }
                        }}
                        columns={columns}
                        filter={filter}
                        pageSize={50}
                        // kell az id mivel nincs idfield...
                        orderBy={{field: "id", direction: "DESC"}}
                    />}
                </List>
            </Fragment>
        );
    }
}

const PosEditor = connect((state) => {
    return {
        till: state.app.till
    }
})((props) => {
    if (!(props.till && props.till.pos && props.till.pos.id)) {
        return <Box header="Hiba" theme="danger">
            Nem boltba vagy bejelentkezve!
        </Box>;
    }
    return <ComponentLoader
    componentName="PointOfSale"
    componentId={props.till.pos.id}
    view={["partner"]}
    dynamic={true}
>
    <ComponentConfig componentName="StockItem">
        <ShopItemStockEditor {...props}/>
    </ComponentConfig>
</ComponentLoader>
});

export default (props) => <ComponentConfig
    componentName="location"
    componentConfigAs="locationConfig"
>
    <PosEditor {...props} />
</ComponentConfig>;

